import { CircularProgress, Input, makeStyles, Theme } from '@material-ui/core';
import { StyleRules } from '@material-ui/core/styles';
import cx from 'classnames';
import React, { useState } from 'react';
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';

import commonStyles from '../../../../assets/jss/commonStyles';
import Button from '../../../../components/CustomButtons/Button.jsx';
import * as nexodusActions from '../../../../store/actions/nexodus_actions';
import { IState } from '../../../../store/reducers';
import { IStyleProps, PropsClasses } from '../../../../types/StyleProps';
import { DispatchProps, Props, StateProps } from './types';

const useStyles = makeStyles<Theme, IStyleProps>(() => commonStyles as StyleRules);

const ImportInvoice: React.FC<Props> = props => {
  const classes: PropsClasses = useStyles({} as IStyleProps);
  const { translate, connectionStatus, importInvoiceStatus, nexodusImportInvoiceRequest } = props;

  const [invoiceNumber, setInvoiceNumber] = useState('');

  const handleImport = () => {
    if (!invoiceNumber) {
      return;
    }
    nexodusImportInvoiceRequest(invoiceNumber);
  };

  if (connectionStatus !== 'ok') {
    return (
      <a className={classes.linkInline} href="/admin/nexudus-app">
        {translate('nexudus.go_to_settings')}
      </a>
    );
  }

  return (
    <>
      <p className={classes.bodyLg}>{translate('nexudus.import_invoice_by_number')}</p>
      <div className={cx(classes.runLabel, classes.flexCenter)}>
        <div className={cx(classes.selectSmall, classes.contentContainer, classes.flexCenter, classes.widthAuto)}>
          <label className={classes.datepickerLabel}>{translate('nexudus.invoice_number_label')}</label>
          <Input type="text" value={invoiceNumber} onChange={(e: any) => setInvoiceNumber(e.target.value)} />
        </div>
        <Button className={classes.formButton} type="button" color="primary" onClick={handleImport}>
          {translate('run.run')}
        </Button>
      </div>
      {importInvoiceStatus === 'loading' && <CircularProgress />}
      {importInvoiceStatus === 'ok' && (
        <p className={classes.iconGreen}>{translate('successfully_imported', undefined, { renderInnerHtml: true })}</p>
      )}
      {importInvoiceStatus === 'failed' && <p className={classes.iconRed}>{translate('unsuccessfully_imported')}</p>}
    </>
  );
};

const mapStateToProps = (state: IState): StateProps => ({
  connectionStatus: state.nexudus.connectionStatus,
  importInvoiceStatus: state.nexudus.importInvoiceStatus,
});

const mapDispatchToProps: DispatchProps = {
  nexodusImportInvoiceRequest: nexodusActions.nexodusImportInvoiceRequest,
};

export default connect<StateProps, DispatchProps, {}, any>(
  mapStateToProps,
  mapDispatchToProps,
)(withLocalize(ImportInvoice));
